/** Port von `BaseDialog/IwmDialogDokumentUpload.razor`. */

import { Dialog, ProgressButton, TextBox, Uploader } from '@/components/ui';
import type { Document } from '@/types/entities';

import { withMatchcode } from './matchcode';
import { useDocumentUploadDialog } from './useDocumentUploadDialog';

export interface DocumentUploadDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  /** Zusatz im Titel, z. B. `"Container ABC123"` — leer ⇒ Titel ohne Zusatz. */
  matchcode: string;
  /** Wird vor dem Speichern auf das Modell angewandt (setzt `ContainerId` bzw. `ReceiptId`). */
  prepareModel: (model: Document) => Document;
}

export function DocumentUploadDialog(props: DocumentUploadDialogProps) {
  const state = useDocumentUploadDialog({
    open: props.open,
    prepareModel: props.prepareModel,
    onClose: props.onClose,
    onSuccess: props.onSuccess,
  });

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      width="650px"
      showCloseIcon
      isModal
      header={withMatchcode('Upload Document', props.matchcode)}
    >
      <div className="row">
        <form>
          <div className="row">
            <div className="col-lg-12">
              <TextBox
                value={state.model.Bezeichnung}
                onChange={state.setBezeichnung}
                label="File name"
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: '1rem' }}>
            <div className="col-lg-12">
              <Uploader
                allowMultiple={false}
                allowedExtensions={state.allowedFileExtensions}
                maxFileSize={state.allowedFileSize}
                onChange={(files) => {
                  void state.selectFiles(files);
                }}
                onRemove={state.removeFile}
              />
            </div>
          </div>
        </form>
      </div>
      <div className="row" style={{ marginTop: '1rem', marginBottom: '1rem', float: 'right' }}>
        <div className="col-lg-12">
          <ProgressButton
            content="Save"
            primary
            type="submit"
            progress={state.saving}
            disabled={!state.valid}
            onClick={state.save}
          />
        </div>
      </div>
    </Dialog>
  );
}

export default DocumentUploadDialog;
